export default {
  'loanPayment.emptyAcctList': '<%= acct %> account is required to initiate a <%= type %>',
  'sendLoanPayment.type.draw': 'Draw',
  'sendLoanPayment.attached': 'Attached Below',
  'loanPayment.alert.title': 'Submit Payment',
  'loanPayment.loanInformation': 'Loan Information',
  'loanPayment.paymentInformation': 'Payment Information',
  'loanPayment.drawInformation': 'Draw Information',
  'loanPayment.nonZero': 'Amount must be greater than 0.00',
  'loanPayment.paymentDetails': 'Payment Details',
  'loanPayment.view.mainAction': 'Copy as New Payment',
  'loanPayment.view.payment.title': 'View Loan Payment',
  'loanPayment.view.draw.title': 'View Loan Draw',
  'loanPayment.create.payment.title': 'Initiate Loan Payment',
  'loanPayment.create.draw.title': 'Initiate Loan Draw',
  'loanPayment.copy.payment.title': 'Copy Loan Payment',
  'loanPayment.copy.draw.title': 'Copy Loan Draw',
  'loanPayment.success': 'Success! Loan has been submitted.',
  'loanPayment.paymentType': 'Payment Type',
  'loanPayment.fromAccount': 'From Account',
  'loanPayment.toAccount': 'To Account',
  'loanPayment.amount': 'Amount',
  'loanPayment.userMessage': 'Reason for Failure',
  'loanPayment.funding': 'Funding',
  'loanPayment.draw': 'Draw',
  'loanPayment.loan': 'Loan',
  'loanPayment.lodepositans': 'Deposit',
  'loanPayment.alert.message': 'You are about to create a',
  'loanPayment.alert.for': 'for',
  'loanPayment.alert.to': 'to',
  'loanPayment.alert.from': 'from',
  'loanPayment.alert.on': 'on'
};
